import { render, staticRenderFns } from "./feedbackSee.vue?vue&type=template&id=61d21292&scoped=true&"
import script from "./feedbackSee.vue?vue&type=script&lang=js&"
export * from "./feedbackSee.vue?vue&type=script&lang=js&"
import style0 from "./feedbackSee.vue?vue&type=style&index=0&id=61d21292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d21292",
  null
  
)

export default component.exports